// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3pvlA{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;height:72px;height:7.2rem;width:72px;width:7.2rem}", ""]);
// Exports
exports.locals = {
	"app__logo": "_3pvlA"
};
module.exports = exports;
